import React from 'react';
import {BooleanField, Datagrid, List, TextField} from 'react-admin';

const FoodTagList = (props) => {
    return (
        <List {...props}>
            <Datagrid rowClick="show">
                <TextField source="name" />
                <BooleanField addLabel source="deleted" />
            </Datagrid>
        </List>
    );
};

export default FoodTagList;